import { defineComponent as t, createBlock as n, openBlock as v, unref as r, mergeProps as m, withCtx as l, createElementVNode as c } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconGoldenGate",
  __name: "IconGoldenGate",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const a = o;
    return (d, e) => (v(), n(r(p), m(a, { "view-box": "0 0 24 24" }), {
      default: l(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M7 2.75A.75.75 0 0 1 7.75 3.5V5c0 1.795.52 3.388 1.325 4.514C9.88 10.64 10.925 11.25 12 11.25c1.076 0 2.12-.61 2.925-1.736C15.73 8.388 16.25 6.794 16.25 5V3.5a.75.75 0 0 1 1.5 0v2c0 2.67.543 5.05 1.385 6.736C20 13.966 21.056 14.75 22 14.75a.75.75 0 0 1 0 1.5h-4.25v4.25a.75.75 0 0 1-1.5 0v-4.25h-8.5v4.25a.75.75 0 0 1-1.5 0v-4.25H2a.75.75 0 0 1 0-1.5c.944 0 2-.784 2.865-2.514C5.707 10.55 6.25 8.17 6.25 5.5v-2A.75.75 0 0 1 7 2.75m12.02 12a8.337 8.337 0 0 1-1.27-1.932v1.932h1.27m-12.77 0H4.98a8.332 8.332 0 0 0 1.27-1.932v1.932m4 0h1v-2.064a4.51 4.51 0 0 1-1-.297v2.361m-1.495-3.34A.757.757 0 0 0 8.75 11.5v3.25h-1v-4.514a6.581 6.581 0 0 0 1.005 1.175m3.995 1.276v2.064h1V12.39a4.51 4.51 0 0 1-1 .297m2.495-1.275A.755.755 0 0 1 15.25 11.5v3.25h1v-4.514a6.576 6.576 0 0 1-1.005 1.175",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
